import { SVGProps } from 'react'

export const NoDataBgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="768"
    height="768"
    viewBox="0 0 768 768"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_5568_10150"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="768"
      height="768"
    >
      <rect width="768" height="768" fill="url(#paint0_radial_5568_10150)" />
    </mask>
    <g mask="url(#mask0_5568_10150)">
      <g clipPath="url(#clip0_5568_10150)">
        <g clipPath="url(#clip1_5568_10150)">
          <line x1="0.5" x2="0.5" y2="768" stroke="#EAECF0" />
          <line x1="48.5" x2="48.5" y2="768" stroke="#EAECF0" />
          <line x1="96.5" x2="96.5" y2="768" stroke="#EAECF0" />
          <line x1="144.5" x2="144.5" y2="768" stroke="#EAECF0" />
          <line x1="192.5" x2="192.5" y2="768" stroke="#EAECF0" />
          <line x1="240.5" x2="240.5" y2="768" stroke="#EAECF0" />
          <line x1="288.5" x2="288.5" y2="768" stroke="#EAECF0" />
          <line x1="336.5" x2="336.5" y2="768" stroke="#EAECF0" />
          <line x1="384.5" x2="384.5" y2="768" stroke="#EAECF0" />
          <line x1="432.5" x2="432.5" y2="768" stroke="#EAECF0" />
          <line x1="480.5" x2="480.5" y2="768" stroke="#EAECF0" />
          <line x1="528.5" x2="528.5" y2="768" stroke="#EAECF0" />
          <line x1="576.5" x2="576.5" y2="768" stroke="#EAECF0" />
          <line x1="624.5" x2="624.5" y2="768" stroke="#EAECF0" />
          <line x1="672.5" x2="672.5" y2="768" stroke="#EAECF0" />
          <line x1="720.5" x2="720.5" y2="768" stroke="#EAECF0" />
        </g>
        <rect x="0.5" y="0.5" width="767" height="767" stroke="#EAECF0" />
        <g clipPath="url(#clip2_5568_10150)">
          <line y1="47.5" x2="768" y2="47.5" stroke="#EAECF0" />
          <line y1="95.5" x2="768" y2="95.5" stroke="#EAECF0" />
          <line y1="143.5" x2="768" y2="143.5" stroke="#EAECF0" />
          <line y1="191.5" x2="768" y2="191.5" stroke="#EAECF0" />
          <line y1="239.5" x2="768" y2="239.5" stroke="#EAECF0" />
          <line y1="287.5" x2="768" y2="287.5" stroke="#EAECF0" />
          <line y1="335.5" x2="768" y2="335.5" stroke="#EAECF0" />
          <line y1="383.5" x2="768" y2="383.5" stroke="#EAECF0" />
          <line y1="431.5" x2="768" y2="431.5" stroke="#EAECF0" />
          <line y1="479.5" x2="768" y2="479.5" stroke="#EAECF0" />
          <line y1="527.5" x2="768" y2="527.5" stroke="#EAECF0" />
          <line y1="575.5" x2="768" y2="575.5" stroke="#EAECF0" />
          <line y1="623.5" x2="768" y2="623.5" stroke="#EAECF0" />
          <line y1="671.5" x2="768" y2="671.5" stroke="#EAECF0" />
          <line y1="719.5" x2="768" y2="719.5" stroke="#EAECF0" />
          <line y1="767.5" x2="768" y2="767.5" stroke="#EAECF0" />
        </g>
        <rect x="0.5" y="0.5" width="767" height="767" stroke="#EAECF0" />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_5568_10150"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(384 384) rotate(90) scale(384 384)"
      >
        <stop />
        <stop offset="1" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_5568_10150">
        <rect width="768" height="768" fill="white" />
      </clipPath>
      <clipPath id="clip1_5568_10150">
        <rect width="768" height="768" fill="white" />
      </clipPath>
      <clipPath id="clip2_5568_10150">
        <rect width="768" height="768" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
